import { BaseModel } from '../../_base/crud';

export class SalesTeam extends BaseModel {
  id;
  name;
  manager;
  manager_id;
  calls_on;
  filters;
  type;
  is_active;
  members;
}
